export default __webpack_public_path__ + "static/media/assets.965a2e15.svg";